import React, { useState } from "react";
import { AttendanceRecord, RequestBody } from "../../features/attendanceCorrection/attendanceCorrectionTypes";
import {  Card, CardContent, TextField } from "@mui/material";
import "./attendanceCorrectionCard.css";
import { getRequestBody } from "../../features/attendanceCorrection/attendanceCorrectionService";
import { usePortalTranslation , TranslationEnum} from "../../providers/TranslationProvider";
type Props = {
  rejectAttendance: (requestBody: RequestBody) => void;
  userAttendanceInfo: AttendanceRecord; 
};
const AttendanceCorrectionCard: React.FC<Props> = ({
  rejectAttendance,
  userAttendanceInfo,
}) => {
  const { translate } = usePortalTranslation();

  const [message, setMessage] = useState("");

  const handleRejectClick = () => {
    if (!userAttendanceInfo) return;
    const requestBody = getRequestBody(userAttendanceInfo, message);
    rejectAttendance(requestBody);
  };

  if (!userAttendanceInfo) {
    return null;
  }

  const attendanceTypeColor =
    userAttendanceInfo.attendanceType?.[0] === "present" ? "green" : "red";
  const styles = {
    card: {
      margin: "16px",
      padding: "16px",
      BorderLeft: `4px solid ${attendanceTypeColor}`,
      BorderRadius: "4px",
    },
  };
  return (
    <Card style={styles.card} className="user-attendance-card-wrapper">
      <CardContent>
        <div className="user-attendance-info-wrapper">
          <div className="user-attendance-name-and-time-container">
            <div className="user-attendance-name">
              {userAttendanceInfo?.name}
            </div>
            <div className="user-attendance-time">
              {userAttendanceInfo?.creationTime}
            </div>
          </div>
          <div className="user-attendance-type-container">
            <div
              className="user-attendance-type-indicator "
              style={{
                backgroundColor: attendanceTypeColor,
              }}
            ></div>
            <div className="user-attendance-type-value">
              {userAttendanceInfo.attendanceType?.[0] || "N/A"}
            </div>
          </div>
        </div>
        <div className="user-attendance-message-and-button-wrapper">
          <TextField
            className="user-attendance-message"
            label="Manager Comment"
            variant="outlined"
            fullWidth
            margin="normal"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <div
            className="user-attendance-button"
            onClick={handleRejectClick}
          >
            {translate(TranslationEnum.common_portal,"Reject")}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AttendanceCorrectionCard;
